import { ReactChild, ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { CacheService } from 'services';

// Configuration
import Configuration from 'core/configuration';

// Types
interface IProps {
  children: ReactChild;
}

export const Auth0ProviderWithHistory = ({ children }: IProps): ReactElement => {
  const history = useHistory();

  const onRedirectCallback = (appState: AppState) => {
    const redirectToUri = CacheService.get(appState?.returnTo);
    // After getting the redirect uri, clear out the cached value
    CacheService.remove(appState?.returnTo);
    history.push(redirectToUri || window.location.pathname);
  };

  return (
    <Auth0Provider
      audience={Configuration.authAudience}
      clientId={Configuration.authClientId}
      domain={Configuration.authDomain}
      onRedirectCallback={onRedirectCallback}
      redirectUri={Configuration.authRedirectUri}
      scope={Configuration.authScope}
    >
      {children}
    </Auth0Provider>
  );
};
